import React from 'react';

export const AIIcon: React.FC<{ size?: number; color?: string }> = ({ size = 24, color = 'white' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Modern AI sparkle/star icon */}
    <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill={color} opacity="0.9" />
    <path d="M19 5L19.5 7L21.5 7.5L19.5 8L19 10L18.5 8L16.5 7.5L18.5 7L19 5Z" fill={color} opacity="0.7" />
    <path d="M5 14L5.5 16L7.5 16.5L5.5 17L5 19L4.5 17L2.5 16.5L4.5 16L5 14Z" fill={color} opacity="0.7" />
  </svg>
);
